import { QUERY_PARAM } from '../flow-settings/QUERY_PARAM';
import { getQueryParam } from './getQueryParam';
export const getResurrectionAttempt = () => {
  const resurrectionCountQueryParam = getQueryParam(QUERY_PARAM.RESURRECTION_COUNT);
  return resurrectionCountQueryParam ? Number(resurrectionCountQueryParam) + 1 : 0;
};